import React, {useState, useEffect, useRef, useMemo} from "react";
import { Helmet } from "react-helmet";
import ImageSorter from "@utils/ImageSorter";
import getBoxPadUrl from "@utils/getBoxPadUrl"

const StructuredDataProduct = props => {

        

    const {product, images, navigationStore, inStock} = props;
    //const {structuredData, setStructuredData} = useState({});

    if (!navigationStore.marketSettings.StructuredData) {
        return false;
    }

    const getProductUrl = (product, groupByValue) => {
        return navigationStore.getProductUrl(product, groupByValue);
    };

    // const imageWidthDefault = 1440;
    // const imageHeightDefault = imageWidthDefault * 1.499;
    
    let absolutLinkedImages = [];

    images.forEach(image => {
        absolutLinkedImages.push(navigationStore.marketSettings.StructuredData.Website.Url + image);
    });

    //images = ImageSorter(images);

    let structuredData = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": product.DisplayName,
        "url": (navigationStore.marketSettings.StructuredData.Website.Url || "") + getProductUrl(product, product.UrlSlug),
        "image": absolutLinkedImages,
        "description": product.ShortDescription,
        "sku": product.Sku,
        "offers": {
            "@type": "Offer",
            "url": (navigationStore.marketSettings.StructuredData.Website.Url || "") + getProductUrl(product, product.UrlSlug),
            "priceCurrency": product.CurrencyCode,
            "price": product.Price,
            "itemCondition": "https://schema.org/NewCondition",
            "availability": inStock ? "https://schema.org/InStock" : "https://schema.org/OutOfStock"
        }
    }



    return (
        <Helmet>
            <script className={"structured-data"} type="application/ld+json">{JSON.stringify(structuredData)}</script>
        </Helmet>
    );
};
export default StructuredDataProduct;